/*
 |------------------------------------------------------------------------------
 | Save to localStorage transform
 |------------------------------------------------------------------------------
 |
 | This transform will store a piece of the state to localStorage, so we can
 | reference it later on another page or later in the session.
 |
 */

import { pickBy, includes } from 'lodash';

import { setSessionStorage } from '../../session-manager';

export default ({
	// The key we want to use as the localStorage key.
	storageKey,
	// Keys we want to omit when writing our state to local storage.
	omitKeys = []
}) => async ({ currentState }) => {
	setSessionStorage(
		storageKey,
		pickBy(
			currentState,
			(value, key) => !includes(omitKeys, key) && value !== null
		)
	);

	// We don't actually return anything because we don't have to write
	// any new state to the container.
	return null;
};
